import React from "react";
import {RoutersInfo} from "root";
import {useLocation} from "react-router-dom";
import {ButtonMain, FullTable} from "components";
import {Svg} from "assets";

export const MainInfo = ({
                             buttonText,
                             clickToAddButton,
                             headerTable = [],
                             bodyTable = [],
                             listTable = [],
                             listCountTable,
                             handleClickRow = () => {
                             },
                             actionType,
                             emptyState
                         }) => {
    const location = useLocation();
    const {pathname} = location;
    const currentPage = RoutersInfo()?.find((rout) =>
        pathname?.startsWith(rout?.path),
    );
    return (
        <div className="main-info-fragment-wrapper">
            <div className="main-info-fragment-header">
                <p className="main-info-fragment-header-title">{currentPage?.name}</p>

                {(buttonText && !!listTable?.length) && (
                    <ButtonMain
                        text={buttonText}
                        startIcon={<Svg.PlusSvg/>}
                        onClick={clickToAddButton}
                        small
                        buttonMainStyles={{
                            width: "fit-content",
                            padding: "6px 12px",
                        }}
                    />
                )}
            </div>

            <div className="main-info-fragment-content">
                <FullTable
                    head={headerTable}
                    body={bodyTable}
                    list={listTable}
                    listCount={listCountTable}
                    loadingType={actionType}
                    handleClick={handleClickRow}
                    emptyState={emptyState}
                />
            </div>
        </div>
    );
};
